import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import { installPhoneClickTracker } from "./lib/analytics";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import EndOfTenancyCleaningLondon from "./pages/EndOfTenancyCleaningLondon";
import DeepCleaningLondon from "./pages/DeepCleaningLondon";
import CarpetCleaningLondon from "./pages/CarpetCleaningLondon";
import OvenCleaningLondon from "./pages/OvenCleaningLondon";
import Prices from "./pages/Prices";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";
import BoroughPage from "./pages/BoroughPage";
import Admin from "./pages/Admin";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import RequestReceived from "./pages/RequestReceived";
import GetAQuote from "./pages/GetAQuote";
import CustomPage from "./pages/CustomPage";
import { boroughs } from "./data/boroughs";

function App() {
  useEffect(() => {
    installPhoneClickTracker();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route
            path="/end-of-tenancy-cleaning-london"
            element={<EndOfTenancyCleaningLondon />}
          />
          <Route
            path="/deep-cleaning-london"
            element={<DeepCleaningLondon />}
          />
          <Route
            path="/carpet-cleaning-london"
            element={<CarpetCleaningLondon />}
          />
          <Route
            path="/oven-cleaning-london"
            element={<OvenCleaningLondon />}
          />
          {boroughs.map((borough) => (
            <Route
              key={borough.slug}
              path={`/end-of-tenancy-cleaning-${borough.slug}`}
              element={<BoroughPage borough={borough} />}
            />
          ))}
          <Route path="/prices" element={<Prices />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/request-received" element={<RequestReceived />} />
          <Route path="/get-a-quote" element={<GetAQuote />} />
          <Route path="/p/:slug" element={<CustomPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
